import {Component, OnInit} from '@angular/core';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {ApiService} from '../../core/http/api.service';
import {UtilsService} from '../../core/services/utils/utils.service';
import {createCroppedImageFile, isImageFile} from '../../core/services/utils/image-upload.utils';

@Component({
  selector: 'app-ecommerce-categories',
  templateUrl: './ecommerce-categories.component.html',
  styleUrls: ['../ecommerce-shared.css'],
  standalone: false
})
export class EcommerceCategoriesComponent implements OnInit {
  categories: any[] = [];
  loading = false;
  saving = false;
  uploading = false;
  showModal = false;
  showIconCropModal = false;
  editId = '';
  iconImageFile: File = null;
  croppedIconFile: File = null;
  readonly iconAspectRatio = 1;
  form: any = this.emptyForm();

  constructor(private api: ApiService, private utils: UtilsService) {}

  ngOnInit(): void { this.load(); }

  emptyForm(): any {
    return {title: '', slug: '', description: '', iconUrl: '', sortOrder: 0, status: 'published', isActive: true};
  }

  load(): void {
    this.loading = true;
    this.api.getEcommerceCategories().subscribe({
      next: (res) => { this.categories = res.data || []; this.loading = false; },
      error: (err) => { this.loading = false; this.utils.resErr(err); }
    });
  }

  open(item: any = null): void {
    this.editId = item?._id || item?.id || '';
    this.form = item ? {...item} : this.emptyForm();
    this.showModal = true;
  }

  close(): void {
    this.showModal = false;
    this.resetIconCrop();
  }

  uploadIcon(event: any): void {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    if (!isImageFile(file)) {
      this.utils.toastError('Choose a valid image file.');
      return;
    }
    this.iconImageFile = file;
    this.croppedIconFile = null;
    this.showIconCropModal = true;
  }

  onIconImageCropped(event: ImageCroppedEvent): void {
    this.croppedIconFile = createCroppedImageFile(event, `category-icon-${Date.now()}.png`);
  }

  onIconImageLoadFailed(): void {
    this.utils.toastError('Image load failed. Please choose another image.');
    this.resetIconCrop();
  }

  uploadCroppedIcon(): void {
    if (!this.croppedIconFile) {
      this.utils.toastError('Please adjust the crop area before uploading.');
      return;
    }
    this.uploading = true;
    this.api.uploadEcommerceAsset(this.croppedIconFile, 'image').subscribe({
      next: (res) => {
        this.form.iconUrl = res.data?.url || res.data?.location || '';
        this.uploading = false;
        this.resetIconCrop();
      },
      error: (err) => {
        this.uploading = false;
        this.utils.resErr(err);
      }
    });
  }

  closeIconCropModal(): void {
    if (this.uploading) return;
    this.resetIconCrop();
  }

  resetIconCrop(): void {
    this.showIconCropModal = false;
    this.iconImageFile = null;
    this.croppedIconFile = null;
  }

  save(): void {
    if (!this.form.title?.trim()) {
      this.utils.toastError('Title is required.');
      return;
    }
    this.saving = true;
    const request = this.editId
      ? this.api.updateEcommerceCategory(this.editId, this.form)
      : this.api.createEcommerceCategory(this.form);
    request.subscribe({
      next: (res) => { this.saving = false; this.close(); this.utils.toastSuccess(res.message); this.load(); },
      error: (err) => { this.saving = false; this.utils.resErr(err); }
    });
  }

  toggleActive(item: any): void {
    const isActive = item.isActive === false;
    this.api.updateEcommerceCategoryActivation(item._id || item.id, isActive).subscribe({
      next: (res) => {
        item.isActive = isActive;
        this.utils.toastSuccess(res.message || `Category ${isActive ? 'activated' : 'deactivated'}.`);
      },
      error: (err) => this.utils.resErr(err)
    });
  }

  remove(item: any): void {
    if (!confirm(`Delete ${item.title}? Categories with products must be archived instead.`)) return;
    this.api.deleteEcommerceCategory(item._id || item.id).subscribe({
      next: (res) => { this.utils.toastSuccess(res.message); this.load(); },
      error: (err) => this.utils.resErr(err)
    });
  }
}
